import React from "react";
import { Link } from "react-router-dom";
import { useCollection } from "../useData";
import { resolveImg } from "../api";
import SEO from "../components/SEO";

const Exhibitions = () => {
  const exhibitions = useCollection("exhibitions") || [];
  return (
    <div className="px-6 md:px-10 max-w-[1100px] mx-auto">
      <SEO
        title="Installation views"
        description="Solo and group exhibitions by Alice Lisi — Fahey/Klein Gallery Los Angeles, Los Angeles Center of Photography, Maison de la Photographie Lille, Fondazione Cavallerizza Reale, WeGil Roma."
        path="/exhibitions"
      />
      <div className="pt-2 pb-8">
        <span className="font-serif italic text-[color:var(--ink-mute)]">Installation views — exhibitions</span>
      </div>

      <div className="border-t border-[color:var(--line)] pt-10 space-y-24 pb-8">
        {exhibitions.map((ex, i) => (
          <section key={ex.id} id={ex.id}>
            {/* Header row */}
            <Link to={`/exhibitions/${ex.id}`} className="grid grid-cols-12 items-baseline gap-4 pb-6 hover:opacity-70 transition-opacity">
              <span className="col-span-1 font-serif text-[color:var(--ink-mute)] counter">0{i + 1}</span>
              <div className="col-span-11">
                <p className="font-serif italic text-2xl leading-tight">{ex.title}</p>
                <p className="font-serif text-[color:var(--ink-mute)] mt-1">{ex.kind}</p>
              </div>
            </Link>

            {/* First installation view — smaller square (only when image exists) */}
            {ex.images && ex.images.length > 0 ? (
              <Link to={`/exhibitions/${ex.id}`} className="tile block">
                <div className="aspect-square bg-[color:var(--paper-2)] overflow-hidden max-w-[560px] mx-auto">
                  <img src={resolveImg(ex.images[0])} alt={ex.title} loading="lazy" decoding="async" className="tile-img w-full h-full object-cover" />
                </div>
                <div className="max-w-[560px] mx-auto mt-3 flex items-baseline justify-between gap-4">
                  <span className="font-serif text-[color:var(--ink-mute)]">
                    Installation view — {ex.venue}, {ex.city}
                    {ex.dates && <span className="ml-1">· {ex.dates}</span>}
                  </span>
                  <span className="font-serif text-[color:var(--ink-mute)] counter whitespace-nowrap">01 / {String(ex.images.length).padStart(2, "0")}</span>
                </div>
              </Link>
            ) : null}
          </section>
        ))}
      </div>
    </div>
  );
};

export default Exhibitions;
